import { render, staticRenderFns } from "./verificationSuccess.vue?vue&type=template&id=11070d09&"
import script from "./verificationSuccess.vue?vue&type=script&lang=js&"
export * from "./verificationSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports